import {volContainer, soundOnBtn, soundOffBtn, volumeControl} from './BtnVolumeTmpl';

export default class BtnVolume {
    constructor( _container, _option ){
        this.nameIs = 'class-BtnVolume';
        this.container = _container;
        this.option = _option;
        
        this.sto = null;
        this.dragObject = null;
        this.pp = null;
        this.pw = null;

        this.isMuted = true;
        
        this.volContainer = $( volContainer() );
        this.soundOnBtn = $( soundOnBtn() );
        this.soundOffBtn = $( soundOffBtn() );
        this.volumeControl = $( volumeControl() );
        this.volumeBar = this.volumeControl.find('.controlbar-volume-bar');
        
        this.volContainer.append( this.soundOnBtn, this.soundOffBtn, this.volumeControl );
        $(_container).append( this.volContainer );
    }

    addEvents(){
        this.soundOnBtn.on('click', (e)=>{
            $(this.option.el_sel).trigger({type: 'SOUNDON_BTN_CLICK', who: this.nameIs});
            return false;
        });
        this.soundOffBtn.on('click', (e)=>{
            $(this.option.el_sel).trigger({type: 'SOUNDOFF_BTN_CLICK', who: this.nameIs});
            return false;
        });

        this.volumeBar.on('mousedown', (e)=>{
            this.dragObject  = $(e.currentTarget);
            this.updateVolume(e);
        });

        $(document).on('mouseup', (e)=> this.dragObject = null );
        $(document).on('mousemove', (e)=> this.dragObject && this.updateVolume(e) );


        this.volContainer.on('mouseover', (e)=>{
            if(this.isMuted) return false;
            this.volControlShow();
        });

        this.volContainer.on('mouseout', (e)=>{
            clearTimeout(this.sto);
            this.sto = setTimeout(() => {
                this.sto = null;
                this.volControlHide();
            }, 500);
        });
        
    }
    
    volControlShow(){
        clearTimeout(this.sto);
        this.volumeControl.show();
        TweenMax.to(this.volumeControl, 0.3, {css:{opacity:1, y:0}});
    }

    volControlHide(){
        TweenMax.to(this.volumeControl, 0.3, {
            css: {opacity:0, y:10}, 
            ease : Power3.easeOut, 
            onComplete: () => this.volumeControl.hide()
        });
    }

    updateVolume (e){
        if(!this.pp || !this.ph){
            this.pp = this.getParentPosition( this.volumeBar );
            this.ph = this.volumeControl.height();
        }
        
        let pos = e.pageY - this.pp;
        if (pos > this.ph) pos = this.ph;
        if (pos < 0) pos = 0;
        
        let per = 100 - (pos/this.ph*100);
        
        $(this.option.el_sel).trigger({type: 'VOLUME_CHANGE', who: this.nameIs, vol: per });
    }

    mute(){
        this.isMuted = true;
        this.soundOffBtn.show();
        this.soundOnBtn.hide();
        this.volControlHide();
    }
    
    unMute(){
        this.isMuted = false;
        this.soundOnBtn.show();
        this.soundOffBtn.hide();
        this.volControlShow();
    }

    volumeUpdate(_volPer){
        TweenMax.set(this.volumeBar, {y:_volPer + '%'});
    }
    
    getParentPosition(target){
        var top = 0;
        target = target[0];
    
        target = target.offsetParent;
        while (target.offsetParent){
            top += target.offsetTop;
            target = target.offsetParent;
        }
    
        top += target.offsetTop;
        return top;
    }
    
}